import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ApiServices from '../../actions/services';
//' />../../../actions/services';

const GeoPreview = () => {
  const [latitud, setLatitud] = useState('');
  const [longitud, setLongitud] = useState('');
  const [resultado, setResultado] = useState('');
  const [resultado2, setResultado2] = useState('');
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const user = useSelector(state => state.auth?.user);
  const handleBuscar = async () => {
    // Validar que los campos no estén vacíos
    if (!latitud || !longitud) {
      setError('Por favor ingrese latitud y longitud');
      return;
    }

    setCargando(true);
    setError('');
    setResultado('');

    try {
      // Reemplaza esta URL con la URL de tu API
      //const apiUrl = `https://tu-api.com/geocode?lat=${latitud}&lng=${longitud}`;
      
        const estructura = { Latitud: latitud, Longitud: longitud };
        console.log("Enviando estructura a API:", estructura);
        const response = await ApiServices.get("ObtenerDatosRutaTerritorio",estructura,user);
      console.log("Respuesta del API:", response);
      
      if (!response || !response.datos_Generados) {
        throw new Error("Respuesta inválida del API");
      }

      let parsedData;
      try {
        parsedData = JSON.parse(response.datos_Generados);
        console.log(parsedData);
      } catch (parseError) {
        console.error('Error al parsear JSON:', parseError);
        throw new Error("Error al procesar los datos del servidor");
      }
      setResultado(parsedData[0].RUTA);
      setResultado2(parsedData[0].TERRITORIO);
      
    } catch (err) {
      setError(`Error al buscar: ${err.message}`);
      console.error('Error:', err);
    } finally {
      setCargando(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBuscar();
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.titulo}>Geo Preview</h1>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>
          Latitud:
          <input
            type="number"
            step="any"
            value={latitud}
            onChange={(e) => setLatitud(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Ej: -34.6037"
            style={styles.input}
          />
        </label>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>
          Longitud:
          <input
            type="number"
            step="any"
            value={longitud}
            onChange={(e) => setLongitud(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Ej: -58.3816"
            style={styles.input}
          />
        </label>
      </div>

      <button 
        onClick={handleBuscar} 
        disabled={cargando}
        style={cargando ? styles.buttonDisabled : styles.button}
      >
        {cargando ? 'Buscando...' : 'Buscar'}
      </button>

      {error && (
        <div style={styles.error}>
          {error}
        </div>
      )}

      {resultado && (
        <div style={styles.resultContainer}>
          <label style={styles.resultLabel}>
            RUTA:
          </label>
          <div style={styles.resultText}>
            {resultado}
          </div>
        </div>
      )}
        {resultado2 && (
        <div style={styles.resultContainer}>
          <label style={styles.resultLabel}>
            TERRITORIO:
          </label>
          <div style={styles.resultText}>
            {resultado2}
          </div>
        </div>
      )}
    </div>
  );
};

// Estilos básicos (puedes usar CSS modules o styled-components)
const styles = {
  container: {
    maxWidth: '500px',
    margin: '50px auto',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    backgroundColor: '#f9f9f9',
    fontFamily: 'Arial, sans-serif'
  },
  titulo: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '30px'
  },
  formGroup: {
    marginBottom: '20px'
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    color: '#555',
    fontWeight: 'bold'
  },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '16px',
    boxSizing: 'border-box'
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s'
  },
  buttonDisabled: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#ccc',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'not-allowed'
  },
  error: {
    marginTop: '20px',
    padding: '10px',
    backgroundColor: '#ffebee',
    color: '#c62828',
    borderRadius: '5px',
    textAlign: 'center'
  },
  resultContainer: {
    marginTop: '20px',
    padding: '15px',
    backgroundColor: '#e8f5e9',
    borderRadius: '5px',
    borderLeft: '4px solid #4caf50'
  },
  resultLabel: {
    fontWeight: 'bold',
    color: '#2e7d32',
    marginBottom: '8px',
    display: 'block'
  },
  resultText: {
    color: '#333',
    wordWrap: 'break-word'
  }
};

export default GeoPreview;